import React from 'react'
import { HiOutlineUserGroup } from "react-icons/hi";

const Card = ({tabIndex, title, count, percentage, description, handleClick, name }) => {
  return (
    <>
      <div tabindex={tabIndex || "0"} className={`w-full bg-[#FFFFFF] border border-[#2121211A]/10 p-4 rounded-md flex items-start justify-between transition-all duration-300  hover:text-white bghover  focus:text-white focus:bghover focus:bg-[#F29F67]  h-full cursor-pointer`} onClick={() => handleClick(name)}>
        <div>
          <h3 className="text-sm font-semibold uppercase top-0">{title}</h3>
          <p className="text-2xl font-bold mt-1">{count}</p>
          <div className="text-sm flex 2xl:flex-row flex-col 2xl:items-center gap-1 mt-2">
            <span className={`font-semibold text-xs  ${percentage?.isPositive ? "text-green-500" : "text-red-500"}`}>{percentage?.change || ""}</span>
            <span>{description || ""}</span>
          </div>
        </div>
        <div className="bg-gray-100 p-4 rounded-md">
          <HiOutlineUserGroup   className='textcolor 2xl:text-[2rem] text-[1.3rem]' />
        </div>
      </div>
    </>
  )
}

export default Card